import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e621b9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notify-setting-box" }
const _hoisted_2 = { class: "scroll-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-box" }, "选「不推送」只是关掉推送，已经填好的地址会保留下来。", -1))
const _hoisted_4 = { class: "tips-box" }
const _hoisted_5 = {
  key: 0,
  class: "help-box"
}
const _hoisted_6 = {
  key: 0,
  class: "help-content"
}
const _hoisted_7 = { class: "help-name" }
const _hoisted_8 = { class: "help-steps" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "store-title-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "store-title" }, "门店订阅"),
  /*#__PURE__*/_createElementVNode("span", { class: "store-tips" }, "每个门店可以单独选收哪些通知，只影响你自己；从没配过的默认全收。表头的全选只管当前这一页。")
], -1))
const _hoisted_11 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_ui_radio_card = _resolveComponent("ui-radio-card")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_dialog_container = _resolveComponent("ui-dialog-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_dialog_container, null, {
    header: _withCtx(() => [
      _createVNode(_component_ui_dialog_title, {
        title: "推送设置",
        onClose: _ctx.close
      }, null, 8, ["onClose"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ui_form, { "label-width": "110px" }, {
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, { label: "通知渠道" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_radio_card, {
                    modelValue: _ctx.form.notifyType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.notifyType) = $event)),
                    list: _ctx.channelList
                  }, null, 8, ["modelValue", "list"]),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, {
                label: "通知地址",
                required: _ctx.form.notifyType != 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.notifyUrl,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.notifyUrl) = $event)),
                    placeholder: _ctx.urlPlaceholder,
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.urlTips), 1),
                  (_ctx.helpList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          underline: false,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showHelp = !_ctx.showHelp))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showHelp ? '收起获取步骤' : '怎么找到这个地址？'), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.showHelp)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.helpList, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "help-item",
                                  key: item.name
                                }, [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                                  _createElementVNode("ol", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.steps, (step, index) => {
                                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(step), 1))
                                    }), 128))
                                  ]),
                                  _createElementVNode("a", {
                                    class: "help-link",
                                    href: item.doc,
                                    target: "_blank",
                                    rel: "noopener"
                                  }, _toDisplayString(item.docName), 9, _hoisted_9)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["required"])
            ]),
            _: 1
          }),
          _hoisted_10,
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            border: "",
            data: _ctx.pageRows,
            "empty-text": "你还没有加入任何门店"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "60",
                align: "center"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": _ctx.allRowsChecked,
                    indeterminate: _ctx.allRowsIndeterminate,
                    disabled: !_ctx.pageRows.length,
                    onChange: _ctx.toggleAllRows
                  }, null, 8, ["model-value", "indeterminate", "disabled", "onChange"])
                ]),
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": _ctx.isRowAll(row),
                    indeterminate: _ctx.isRowIndeterminate(row),
                    onChange: (checked) => _ctx.toggleRow(row, checked)
                  }, null, 8, ["model-value", "indeterminate", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "storeName",
                label: "门店名称",
                "min-width": "180",
                "show-overflow-tooltip": ""
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventList, (item) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: item.value,
                  label: item.name,
                  width: "140",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_checkbox, {
                      "model-value": row.events.includes(item.value),
                      onChange: (checked) => _ctx.setEvent(row, item.value, checked)
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.loading]
          ]),
          (_ctx.storeRows.length > _ctx.pageSize)
            ? (_openBlock(), _createBlock(_component_ui_page, {
                key: 0,
                modelValue: _ctx.pageNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageNo) = $event)),
                info: _ctx.pageInfo
              }, null, 8, ["modelValue", "info"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.saveLoading,
            disabled: _ctx.saving,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_el_button, {
            loading: _ctx.testLoading,
            disabled: _ctx.saving,
            onClick: _ctx.saveAndTest
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存并测试")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}